import axios from '@/utils/request';

export async function searchHistory(params) {
    return axios.get('product/search/history', params);
}